


















import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {ListSection} from '@/store/models';
import Toggle from '@/views/document/section/Toggle.vue';

@Component({components: {Toggle, List}})
export default class Completion extends Vue {
  @Prop() readonly group!: any;

  @Watch('miscSection', {immediate: true, deep: true})
  onData1() {
    this.onData();
  }

  onData() {
    if (this.group.Hidden !== this.hidden) {
      const g = {
        Id: this.group.Id,
        Kind: this.group.Kind,
        Type: this.group.Type,
        SubType: this.group.SubType,
        Children: this.group.Children,
        Hidden: this.hidden,
      };
      dokument.updateItem(g);
    }
  }

  get miscSection(): ListSection {
    return dokument.getItems(this.group.Id)[1] as ListSection;
  }

  get feedbackSection(): any {
    return dokument.getItems(this.group.Id)[2];
  }

  get nextSection(): any {
    return dokument.getItems(this.group.Id)[3];
  }

  get hidden(): boolean {
    return this.miscSection.Hidden === true &&
        this.feedbackSection.Hidden === true &&
        this.nextSection.Hidden === true;
  }
}
